import React from "react";
import { useNavigate } from "react-router-dom";
// import CustomViewButton from "../../CustomComponent/custom_view_button";
// import CustomViewButton from "../../../CustomComponent";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Person Name",
  "contact",
  "city",
  //   "Webinar End Time",
  "Actions",
];
const WebinarInterestTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

//   console.log("Data", data);

  const goToView = (id) => {
    //   navigate(`/webinar-tickets/view/${id}`);
    navigate(`/webinarInterest/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.personName || "N/A"}</td>
                <td>{item?.contact || "N/A"}</td>
                <td>{item?.city || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WebinarInterestTable;
